<template>
  <div
    class="management-bd tb"
    v-if="funcView.bankCard_manage_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button
            v-if="funcView.bankCard_manage_add"
            type="primary"
            icon="el-icon-plus"
            @click="onAddBtn"
          >{{ funcView.bankCard_manage_add }}
          </el-button>
        </el-form-item>
        <el-form-item
          v-if="funcView.backCard_export"
          style="float: right; margin-right: 0"
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{'mr-0':!funcView.backCard_export}"
        >
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.keyword"
            :placeholder="$t('fms_bankCard.khmyhzh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        index
        v-loading="isLoading"
        :data="bankcardList"
        :column="tableColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['action']"
      >

        <template v-slot:action="scope">
          <span></span>
          <el-button
            type="text"
            size="mini"
            @click="onEditBtn(scope.row)"
            v-if="funcView.bankCard_manage_edit"
          >{{ funcView.bankCard_manage_edit }}</el-button>
          <el-button
            type="text"
            size="mini"
            @click="onDefaultBtn(scope.row.bankcardId)"
            v-if="funcView.bankCard_manage_default&&!scope.row.isDefault"
          >{{ funcView.bankCard_manage_default }}</el-button>
          <template v-if="hasOneTrue(funcView.bankCard_manage_delete, (funcView.bankCard_manage_disable&&scope.row.state), (funcView.bankCard_manage_enable&&!scope.row.state))">
            <el-button
              type="text"
              size="mini"
              @click="onDeleteBtn(scope.row.bankcardId)"
              v-if="funcView.bankCard_manage_delete"
            >{{ funcView.bankCard_manage_delete }}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="onDisableBtn(scope.row.bankcardId)"
              v-if="funcView.bankCard_manage_disable&&scope.row.state"
            >{{ funcView.bankCard_manage_disable }}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="onEnableBtn(scope.row.bankcardId)"
              v-if="funcView.bankCard_manage_enable&&!scope.row.state"
            >{{ funcView.bankCard_manage_enable}}</el-button>
          </template>
          <template v-else>
            <el-dropdown>
              <span class="el-dropdown-more">
                {{ $t('fms_bankCard.geng_duo') }}
                <i class="icon icon-xiala"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="funcView.bankCard_manage_delete"
                  @click.native="onDeleteBtn(scope.row.bankcardId)"
                >
                  {{ funcView.bankCard_manage_delete }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="funcView.bankCard_manage_disable&&scope.row.state"
                  @click.native="onDisableBtn(scope.row.bankcardId)"
                >
                  {{ funcView.bankCard_manage_disable }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="funcView.bankCard_manage_enable&&!scope.row.state"
                  @click.native="onEnableBtn(scope.row.bankcardId)"
                >
                  {{ funcView.bankCard_manage_enable }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!--添加银行卡-->
    <bankcard-address-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getBankcardList"
    >
    </bankcard-address-dialog>
  </div>

</template>

<script>
import apis from '@/utils/apis';
// import bankcardAddressDialog from './children/bankCardDialog.vue';
import bankcardAddressDialog from '@/pages/crm/components/bankCardDialog.vue';

export default {
  name: 'bankcard',
  components: { bankcardAddressDialog },
  data() {
    return {
      tableCode: 'bank_card_list',
      formSearch: {
        pageSize: 50,
        pageNum: 1,
      },
      bankcardList: [],
      tableColumn: [],
      totalRows: null,
      // 编辑地址
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();


    this.getBankcardList();
  },
  methods: {
    // 判断是否只有一个选项是true
    hasOneTrue(...args) {
      const arr = [...args];
      const ret = arr.filter(item => !!item);
      return ret.length === 1;
    },
    // 获取银行卡
    getBankcardList: function () {
      this.isLoading = true;
      this.$getJSON(apis.crmCrmPartnerBankcardPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.bankcardList = res.data.records;
        this.totalRows = res.data.total;

        // this.bankcardList = res.data || [];
      });
    },
    // 编辑银行卡
    onEditBtn: function (item) {
      // alert(3);
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('Common.com_edit');
      this.dialogModel.type = 'edit';
      this.dialogModel.data = { item };

      // this.dialogModel.id = item.bankcardId;
    },
    // 新增银行卡
    onAddBtn: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('Common.com_add');
      this.dialogModel.type = 'add';
      // alert(123);
    },
    // 删除
    onDeleteBtn: function (bankcardId) {
      const tips = this.$t('fms_bankCard.nqdyscxzdyhkm');
      this.$showConfirm(tips).then(() => {
        this.$deleteJSON(`${apis.partnerBankcardDelete}/${bankcardId}`).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success'
            });
            this.getBankcardList();
          }
        });
      })
        .catch(() => { });

    },
    // 设为默认
    onDefaultBtn: function (bankcardId) {
      const tips = this.$t('fms_bankCard.nqdyjxzdyhkswmryhkm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.partnerBankcardDefualt}/${bankcardId}`).then(() => {

          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getBankcardList();

        });
      })
        .catch(() => { });
    },
    // 设为禁用
    onDisableBtn: function (bankcardId) {
      const tips = this.$t('fms_bankCard.nqdyjyxzdyhkm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.PartnerBankcardDisableOrEnable}/${bankcardId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getBankcardList();
        });
      })
        .catch(() => { });
    },
    // 启用
    onEnableBtn: function (bankcardId) {
      const tips = this.$t('fms_bankCard.nqdyqyxzdyhkm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.PartnerBankcardDisableOrEnable}/${bankcardId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getBankcardList();
        });
      })
        .catch(() => { });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getBankcardList();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(
        apis.DeviceResumeComponentEventExport,
        Object.assign(this.formSearch, {})
      ).then(() => { });
    },
  }
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';

.fiance-bankcard-bd {
  margin: 16px 16px 0 16px;
  background: #fff;
  .bankcard {
    h2 {
      font-size: 16px;
      padding-left: 32px;
      height: 56px;
      line-height: 56px;
      border: 1px solid #e9e9e9;
    }
    .bankcard-body {
      padding: 0px 0 32px 32px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      p {
        font-size: 14px;
        height: 22px;
        line-height: 22px;
        margin-top: 20px;
        color: rgba(0, 0, 0, 0.45);
      }
      ul {
        display: flex;
        flex-flow: wrap;
        li.card {
          margin: 20px 20px 0 0;
          height: 198px;
          width: 360px;
          background-color: #fff;
          border: 1px solid rgba(217, 217, 217, 1);
          // padding: 20px 0 0 20px;
          position: relative;
          border: 1px solid rgba(228, 228, 228, 1);
          .type {
            height: 56px;
            border-bottom: 1px solid rgba(217, 217, 217, 1);
            padding: 0 16px 0 24px;
            display: flex;
            align-items: center;
            background: rgba(245, 252, 255, 1);
            .logo {
              display: inline-block;
              width: 32px;
              height: 32px;
              flex: 0 0 32px;
              background-color: #262626;
            }
            p {
              margin: 0 0 0 20px;
              flex: 1;
              color: rgba(0, 0, 0, 0.85);
              // line-height: 56px
            }
            span {
              width: 52px;
              height: 26px;
              flex: 0 0 52px;
              font-size: 14px;
              color: #fff;
              line-height: 26px;
              text-align: center;
              background: rgba(247, 181, 0, 1);
            }
          }
          .content {
            height: 142px;
            padding-top: 40px;
            text-align: center;
            position: relative;
            color: rgba(0, 0, 0, 0.85);
            font-size: 24px;
            .operation {
              position: absolute;
              right: 16px;
              bottom: 16px;
              color: $main-color;
              height: 28px;
              a {
                margin-left: 20px;
                font-size: 12px;
                cursor: pointer;
              }
            }
          }
        }
        li.add {
          margin: 20px 0 0 0;
          width: 198px;
          height: 198px;
          text-align: center;
          background: #f5fcff;
          border: 1px solid rgba(217, 217, 217, 1);
          cursor: pointer;
          .add-liaison {
            font-size: 36px;
            color: rgba(0, 0, 0, 0.45);
            display: block;
            margin-top: 69px;
          }
          span {
            font-style: 14px;
            color: rgba(0, 0, 0, 0.45);
            margin-top: 10px;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>
